'use client';

import { Menu, X } from 'lucide-react';
import Image from 'next/image';
import { useState } from 'react';
import type { Locale } from '@/i18n/i18n';
import { Link, usePathname } from '@/i18n/navigation';

export default function SiteNav({ locale }: { locale: Locale }) {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  const greek = locale === 'el';
  const close = () => setOpen(false);
  const links = [
    { id: 'services', title: greek ? 'Υπηρεσίες' : 'Services' },
    { id: 'vehicle', title: greek ? 'Το ταξί μας' : 'Our taxi' },
    { id: 'destinations', title: greek ? 'Προορισμοί' : 'Destinations' },
  ];

  return (
    <header className={`site-nav${open ? ' is-open' : ''}`}>
      <Link
        href="/"
        className="nav-identity"
        onClick={close}
        aria-label={
          greek ? 'Ταξί Αλεξανδρούπολη — Αρχική' : 'Alexandroupolis taxi — Home'
        }
      >
        <Image
          src="/taxi-logo.png"
          alt={greek ? 'Ταξί Αλεξανδρούπολη' : 'Alexandroupolis Taxi'}
          width={64}
          height={64}
          sizes="(max-width: 760px) 56px, 64px"
          loading="eager"
          className="nav-logo"
        />
      </Link>
      <nav
        id="primary-navigation"
        className="nav-links"
        aria-label={greek ? 'Κύρια πλοήγηση' : 'Main navigation'}
      >
        {links.map(({ id, title }) => (
          <Link key={id} href={`/#${id}`} onClick={close}>
            {title}
          </Link>
        ))}
        <a href="tel:+306944379553" className="nav-book" onClick={close}>
          {greek ? 'Επικοινωνία' : 'Get in touch'}
        </a>
      </nav>
      <div className="nav-controls">
        <Link
          href={pathname}
          locale={greek ? 'en-US' : 'el'}
          hrefLang={greek ? 'en-US' : 'el'}
          className="nav-language"
          aria-label={
            greek
              ? 'View website in English'
              : 'Προβολή ιστοσελίδας στα Ελληνικά'
          }
          onClick={close}
        >
          {greek ? 'EN' : 'ΕΛ'}
        </Link>
        <button
          type="button"
          className="nav-menu"
          aria-label={
            open
              ? greek
                ? 'Κλείσιμο μενού'
                : 'Close menu'
              : greek
                ? 'Άνοιγμα μενού'
                : 'Open menu'
          }
          aria-expanded={open}
          aria-controls="primary-navigation"
          onClick={() => setOpen(!open)}
          onKeyDown={(event) => {
            if (event.key === 'Escape') close();
          }}
        >
          {open ? (
            <X size={22} aria-hidden="true" />
          ) : (
            <Menu size={22} aria-hidden="true" />
          )}
        </button>
      </div>
    </header>
  );
}
